import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { colors } from '@argo/principles';
import React from 'react';
import RefreshLogo from './RefreshLogo';
const LogoWrapper = _styled("div", {
  target: "eouvoih0"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9LYmJMb2dvL2luZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU04QiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvS2JiTG9nby9pbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNvbG9ycyB9IGZyb20gJ0BhcmdvL3ByaW5jaXBsZXMnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IFJlZnJlc2hMb2dvIGZyb20gJy4vUmVmcmVzaExvZ28nO1xuXG5jb25zdCBMb2dvV3JhcHBlciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG5gO1xuXG4vLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgQHR5cGVzY3JpcHQtZXNsaW50L2V4cGxpY2l0LWZ1bmN0aW9uLXJldHVybi10eXBlXG5jb25zdCBLYmJMb2dvID0gKHtcbiAgaXNJbnZlcnNlLFxuICBoZWlnaHQsXG4gIHdpZHRoLFxuICB0ZXh0SGVpZ2h0LFxuICB0ZXh0V2lkdGgsXG4gIC4uLnJlc3Rcbn0pID0+IHtcbiAgY29uc3QgbG9nb1RleHRDb2xvciA9IGlzSW52ZXJzZSA/IGNvbG9ycy5wcmltYXJ5Lm1hcmluZUJsdWUgOiBjb2xvcnMucHJpbWFyeS53aGl0ZTtcbiAgXG4gIHJldHVybiAoXG4gICAgPExvZ29XcmFwcGVyIHsuLi5yZXN0fT5cbiAgICAgIDxSZWZyZXNoTG9nbyB0ZXh0SGVpZ2h0PXt0ZXh0SGVpZ2h0fSB0ZXh0V2lkdGg9e3RleHRXaWR0aH0gaGVpZ2h0PXtoZWlnaHR9IHRleHRGaWxsQ29sb3I9e2xvZ29UZXh0Q29sb3J9IHdpZHRoPXt3aWR0aH0gLz5cbiAgICA8L0xvZ29XcmFwcGVyPlxuICApO1xufTtcblxuS2JiTG9nby5kaXNwbGF5TmFtZSA9ICdLYmJMb2dvJztcblxuZXhwb3J0IGRlZmF1bHQgS2JiTG9nbztcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const KbbLogo = _ref => {
  let {
    isInverse,
    height,
    width,
    textHeight,
    textWidth,
    ...rest
  } = _ref;
  const logoTextColor = isInverse ? colors.primary.marineBlue : colors.primary.white;
  return React.createElement(LogoWrapper, rest, React.createElement(RefreshLogo, {
    textHeight: textHeight,
    textWidth: textWidth,
    height: height,
    textFillColor: logoTextColor,
    width: width
  }));
};
KbbLogo.displayName = 'KbbLogo';
export default KbbLogo;
//# sourceMappingURL=index.js.map